(ns nosco.richtext.api)

(defprotocol HTMLEditorAPI
  (get-view [api] "Get the underlying EditorView instance")
  (get-state [api] "Get the current EditorState")
  (get-html [api] "Get the current document as html string")
  (get-char-count [api] "Get the current char count")
  (set-html [api html] "Set the current document as html string")
  (reset [api] "Reset the editor to a fresh state.")
  (dispatch [api tr] "Dispatch a transaction to the view"))
